module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "price-group-item col-sm-12"
  }, [_c('div', {
    staticClass: "price-group-item-body"
  }, [(_vm.selectedPrincingType && _vm.selectedPrincingType.id === _vm.PricingTypes.PerPerson) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "pricesRowHolder"
  }, _vm._l((_vm.priceGroup.groupPrices), function(pricePerPerson, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-2 mb-3 pb-3 border-bottom-medium"
    }, [_c('PriceManagerRow', {
      attrs: {
        "currentGroupNameProp": _vm.currentGroupNameProp,
        "priceGroup": _vm.priceGroup,
        "prices": _vm.prices,
        "pricePerPerson": pricePerPerson,
        "disabled": _vm.disabled,
        "showDelete": _vm.priceGroup.groupPrices.length > 1,
        "audienceTypes": _vm.groupAudienceTypesAvailable,
        "editingEvent": _vm.editingEvent
      },
      on: {
        "delete": function($event) {
          return _vm.deletePrincingType($event)
        },
        "updatedCustomInput": function($event) {
          return _vm.updatedCustomInput()
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "mb-3 add d-flex align-items-center fs-small bold",
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.addRowInThisGroup(_vm.priceGroup)
      }
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new price\n                    ")])])])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-52e7df57", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e7df57"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/pricingManager/PriceGroup.vue
// module id = 1478
// module chunks = 0